import { LitElement, html, utils } from './-global.min.js'

class HHHeader extends LitElement {
  constructor() {
    super()

    this.announcementBar = document.querySelector('#announcement-bar')
    this.header = this.querySelector('#header')

    this._calculateHeaderHeight = this._calculateHeaderHeight.bind(this)
    this.openMenu = this.openMenu.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this._attachListeners()
    this._calculateHeaderHeight()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(document.body, ['mini-cart-is-active'])
    if (utils.isTablet()) {
      document.body.style.overflow = 'hidden'
    }
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
    ></slot>`
  }

  _attachListeners() {
    this.addEventListener(
      'announcement-bar::ready',
      this._calculateHeaderHeight
    )
    window.addEventListener('resize', this._calculateHeaderHeight)

    document.querySelector('.js-open-menu__btn').addEventListener('click', this.openMenu)
  }

  openMenu() {
    this.querySelector('.header__inline-menu hh-details-modal').setAttribute('open', true)
    this.querySelector('.header__inline-menu hh-details-modal').setAttribute('is-open', true)
  }

  _removeListeners() {
    this.removeEventListener(
      'announcement-bar::ready',
      this._calculateHeaderHeight
    )
    window.removeEventListener('resize', this._calculateHeaderHeight)
  }

  _calculateHeaderHeight() {
    setTimeout(() => {
      document.documentElement.style.setProperty(
        '--header-spacer',
        (this.announcementBar.offsetHeight || 0) +
          (this.header.offsetHeight || 0) +
          'px'
      )
    }, 100)
  }
}

customElements.define('hh-header', HHHeader)
